import { render, staticRenderFns } from "./PropertyBatchUpdateForm.vue?vue&type=template&id=77442754&scoped=true&"
import script from "./PropertyBatchUpdateForm.vue?vue&type=script&lang=js&"
export * from "./PropertyBatchUpdateForm.vue?vue&type=script&lang=js&"
import style0 from "./PropertyBatchUpdateForm.vue?vue&type=style&index=0&id=77442754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77442754",
  null
  
)

export default component.exports